import React from 'react';
import { ButtonGroup, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { Weekdays } from '../Common';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import BrokerCapacityButton from '../broker/BrokerCapacityButton';

export default class BrokerCard extends React.Component {
    render() {
        const {
            broker,
            provided,
            innerRef,
            compact,
            minimal,
            weekdays,
            selectedWeekRangeDays,
        } = this.props;

        const selectedDate =
            selectedWeekRangeDays && selectedWeekRangeDays.length == 1
                ? selectedWeekRangeDays[0]
                : null;

        return (
            <div
                className={cls('card brokerCard', {
                    compact: !!compact,
                    minimal: !!minimal,
                })}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={innerRef}
            >
                {!compact && (
                    <div className="dragIndicator">
                        <FontAwesomeIcon icon={faEllipsisV} />
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </div>
                )}
                <CardBody>
                    <CardTitle className="text-left d-flex flex-row justify-content-between align-items-center">
                        <span className="mr-2 broker-name">
                            {broker.companyName}
                        </span>
                    </CardTitle>

                    {!compact && !minimal && (
                        <CardBody>
                            <BrokerCapacityButton
                                brokerId={broker.id}
                                size="sm"
                                date={selectedDate}
                            />
                        </CardBody>
                    )}

                    <CardFooter>
                        <ButtonGroup className="" size="sm">
                            {weekdays.map((dayDate) => {
                                const day = Weekdays.find(
                                    (x) => x.id === dayDate.getDay()
                                );
                                return (
                                    <span
                                        key={day.id}
                                        className={cls(
                                            'btn btn-sm btn-outline-secondary scheduledDayIndicator'
                                        )}
                                    >
                                        {day.abbreviationShort}
                                    </span>
                                );
                            })}
                        </ButtonGroup>
                    </CardFooter>
                </CardBody>
            </div>
        );
    }
}
